/** Score an Ollama model name so we prefer capable instruct models over tiny ones. */
export function scoreOllamaModel(name: string): number {
  const n = name.toLowerCase();
  let score = 0;

  const sizeMatch = n.match(/(\d+(?:\.\d+)?)\s*b/);
  if (sizeMatch) {
    const b = parseFloat(sizeMatch[1]);
    if (b >= 70) score += 28;
    else if (b >= 14) score += 50;
    else if (b >= 7) score += 45;
    else if (b >= 3) score += 22;
    else if (b >= 1.5) score += 12;
    else score += 4;
  }

  if (n.includes('qwen')) score += 10;
  if (n.includes('llama3.1') || n.includes('llama3.2') || n.includes('llama3')) score += 6;
  if (n.includes('mistral') || n.includes('mixtral')) score += 6;
  if (n.includes('gemma')) score += 4;
  if (n.includes('instruct') || n.includes('-it') || n.includes(':it')) score += 4;
  if (n.includes('coder')) score += 3;
  if (n.includes('tinyllama') || n.includes('minicpm') || n.includes('0.5b') || n.includes('0.6b')) score -= 10;

  return score;
}

export function pickBestOllamaModel(names: string[], preferred?: string | null): string {
  if (names.length === 0) throw new Error('No Ollama models installed');
  if (preferred) {
    const exact = names.find(n => n === preferred);
    if (exact) return exact;
    const prefix = names.find(n => n.startsWith(preferred));
    if (prefix) return prefix;
  }
  return [...names].sort((a, b) => scoreOllamaModel(b) - scoreOllamaModel(a))[0];
}
